<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useSpeckleManagement } from '@/composables/useSpeckleManagement'
import { useProjectSpeckleStore } from '@/store/projectSpeckle'

import TextField from '@/components/form/TextField.vue'
import GenericDialog from './GenericDialog.vue'
import { SpeckleModelSelect, SpeckleProjectSearch, useSpeckleStore } from '@haskoning/vue-speckle'
import SpeckleLoginRequiredDialog from './SpeckleLoginRequiredDialog.vue'
import { watch } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const projectSpeckleStore = useProjectSpeckleStore()
const speckleStore = useSpeckleStore()

const { exportToSpeckleDialog, message } = storeToRefs(projectSpeckleStore)
const { currentSelection } = storeToRefs(speckleStore)
const speckleManagement = useSpeckleManagement()

const { isValidInput } = speckleManagement

const setSelectedSpeckleModel = (id: string) => {
  store.dispatch('project/setSelectedSpeckleModel', id)
}
const updateCurrentProjectUserSpeckle = async () => {
  await store.dispatch('project/updateCurrentProjectUserSpeckle')
}

watch(
  () => currentSelection.value.model,
  async (value) => {
    if (value) {
      const modelId = value.id
      setSelectedSpeckleModel(modelId)
      await updateCurrentProjectUserSpeckle()
    }
  }
)

const closeDialog = () => {
  exportToSpeckleDialog.value = false
}

const sendToSpeckle = async () => {
  await speckleManagement.exportSectionLinesToSpeckle()
  closeDialog()
}
</script>

<template>
  <GenericDialog
    v-if="speckleManagement.canUseSpeckle"
    v-model="exportToSpeckleDialog"
    @clicked-outside="closeDialog"
  >
    <template #title>Send Dike Profiles, Dike Sections to Speckle</template>
    <template #default>
      <SpeckleProjectSearch
        @link="projectSpeckleStore.updateProjectSpeckle()"
      ></SpeckleProjectSearch>
      <SpeckleModelSelect variant="filled" class="my-2"></SpeckleModelSelect>
      <TextField
        v-model="message"
        label="Version Message"
        :rules="[(v: string) => !!v || 'Commit message is required']"
      ></TextField>
    </template>
    <template #actions>
      <v-btn @click="closeDialog"> Cancel </v-btn>
      <v-btn
        :disabled="!isValidInput"
        @click="sendToSpeckle"
        :loading="speckleManagement.exportingSectionLines.value"
      >
        Send to Speckle
      </v-btn>
    </template>
  </GenericDialog>
  <SpeckleLoginRequiredDialog v-else v-model="exportToSpeckleDialog" @cancel="closeDialog" />
</template>

<style scoped></style>
